import React from 'react';
import './index.css';

const OhNoErrorPageNY = () => {
  return (
    <div className="nyErrorPageWrapper">
      <div className="nyErrorContainer">
        <div className="nyErrorContent">
          <div className="nyErrorIcon">
            <span className="nyErrorEmoji">😔</span>
          </div>
          <h1 className="nyErrorTitle">Oh No!</h1>
          <p className="nyErrorMessage">
            We're sorry, but this page is not available in New York State.
          </p>
          <p className="nyErrorSubtext">
            This site is not authorized by the New York State Department of Financial Services. 
            No mortgage solicitation activity or loan applications for properties located in the 
            State of New York can be facilitated through this site.
          </p>
          <div className="nyErrorActions">
            <button 
              className="nyErrorButton"
              onClick={() => window.history.back()}
            >
              Go Back
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OhNoErrorPageNY;